<template>
  <section id="section-banner">
    <div class="flex-row flex-lg-column-reverse section section-content">
      <img class="brand-intro" src="../assets/img_banner_text.png">
      <div v-if="from!=='app'" class="d-lg-none flex-column ms-app-down">
        <div><img src="../assets/logo_large.png" class="brand-logo"/></div>
        <button v-if="isWxMiniProgram" id="copy" type="button" class="btn btn-success brand-name"
                :data-clipboard-text="apkUrl">下载 APP
        </button>
        <button v-else type="button" class="btn btn-success brand-name" @click="downloadApp">下载 APP</button>
        <!-- <button type="button" class="btn btn-success brand-name" disabled>APP 即将上线</button> -->
      </div>
      <img class="qr-container" src="../assets/img_qr_code.png">
    </div>
  </section>
</template>

<script>
  import Clipboard from 'clipboard';

  export default {
    name: "SectionBanner",
    props: ["from", "apkUrl"],
    data() {
      return {
        isWxMiniProgram: false,
      }
    },
    methods: {
      downloadApp() {
        this.$emit("download")
      },
    },
    mounted() {
      new Clipboard('#copy').on('success', (e) => {
        e.clearSelection();
        this.weui.alert("已复制下载链接，请使用手机自带浏览器下载", () => {
          this.weui.toast("已复制", 1000);
        });
      });
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          this.isWxMiniProgram = true;
        }
      })
    }
  }
</script>
<style scoped>
  @media (max-width: 992px) {
    .section-content {
      padding: 80px 40px 0 40px;
    }

    .brand-intro {
      padding: 25px 20px;
    }

    .qr-container {
      margin: 10px 0 0 30px;
    }

    .ms-app-down > button {
      width: 160px;
      max-width: 50%;
      height: 40px;
      margin-top: 25px;
      font-family: "Tahoma", "宋体", "sans-serif";
    }

    .brand-logo {
      width: 96px;
      height: 96px;
      border-radius: 15px;
    }
  }

  @media (min-width: 992px) {
    .section-content {
      padding-top: 150px;
      padding-left: 200px;
      max-width: 80%;
    }

    .brand-intro {
      max-width: 50%;
    }

    .qr-container {
      flex: 1;
      max-width: 50%;
      margin-left: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SectionBanner.vue